var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 493,
    viewBox: "0 0 1000 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.04 198.765C109.467 206.292 72.5857 267.323 30.9541 295.284L-7.83874 324.995L-6.80144 188.332L-5.37753 0.735734L123.071 -0.195172L530.433 -2.77335C530.433 -2.77335 571.915 -4.07513 616.443 -3.39669L721.823 -4.16042L884.874 -5.34211L942.021 -5.75626C922.42 18.3624 876.492 71.7828 831.169 78.8755C785.536 86.017 734.301 51.9328 686.724 45.3004C640.058 39.0518 596.33 59.0519 550.861 66.5624C506.204 73.1563 458.561 67.4553 417.148 101.566C376.772 135.514 342.095 211.989 297.363 225.567C253.771 238.968 199.904 192.139 155.04 198.765Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1511.64,
    height: 415.96,
    fill: "white",
    transform: "translate(-558 81.7201) rotate(-8.8944)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.eb11588418c13e8022fd5a2d4f473e05.svg";
export { ForwardRef as ReactComponent };